import { toast } from 'vue-sonner'
import { DEFAULT_TOAST_DURATION } from '@/constants/ui'

export function useToast() {
  return {
    info(message: string) {
      toast(message, {
        duration: DEFAULT_TOAST_DURATION,
      })
    },
    success(message: string) {
      toast.success(message, {
        duration: DEFAULT_TOAST_DURATION,
      })
    },
    danger(message: string) {
      toast.error(message, {
        duration: DEFAULT_TOAST_DURATION,
      })
    },
  }
}
